import { render, staticRenderFns } from "./ExemptionAttachments.vue?vue&type=template&id=2c818eb5&scoped=true"
import script from "./ExemptionAttachments.vue?vue&type=script&lang=js"
export * from "./ExemptionAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c818eb5",
  null
  
)

export default component.exports